import { useEffect, useRef, useState } from 'react';
import { useEventCallback } from '@icp/hooks';
import { loadTableInitState } from './utils';
import { clearSetting, saveFavoriteView, saveSetting } from './settingHandler';

export default function useTableSetting({
  defaultTableState,
  settingKey,
  globalSettingKey,
  settingUrl,
}) {
  const [tableState, setTableState] = useState(defaultTableState);
  const [favoriteView, setFavoriteView] = useState({ current: null, viewList: [] });
  const loading = useRef(true);

  useEffect(() => {
    loadTableInitState(settingKey, globalSettingKey, settingUrl, defaultTableState).then((res) => {
      loading.current = false;
      const { favoriteView: fv, ...other } = res;
      setTableState(other);
      setFavoriteView(fv);
    });
  }, [defaultTableState, globalSettingKey, settingKey, settingUrl]);

  const saveTableState = useEventCallback((newState) => {
    return saveSetting(settingKey, newState);
  });

  const clearTableState = useEventCallback(() => {
    clearSetting(settingKey);
  });

  const updateFavoriteView = useEventCallback((newFavoriteView) => {
    if (!settingKey) return;
    setFavoriteView(newFavoriteView);
    saveFavoriteView(settingKey, globalSettingKey, settingUrl, newFavoriteView, favoriteView);
  });

  return {
    loadingState: loading.current,
    // current state
    tableState,
    setTableState,
    saveTableState,
    clearTableState,
    // saved view list
    favoriteView,
    updateFavoriteView,
  };
}
